/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

/**
 * 관리자 권한 목록
 */
export type AdminPermission = typeof AdminPermission[keyof typeof AdminPermission];


export const AdminPermission = {
  DASHBOARD: 'DASHBOARD',
  MAIN_SECTION: 'MAIN_SECTION',
  USERS: 'USERS',
  CONTESTS: 'CONTESTS',
  PROGRAMS: 'PROGRAMS',
  OPERATIONS: 'OPERATIONS',
  STORES: 'STORES',
  STATS: 'STATS',
  SETTINGS: 'SETTINGS',
} as const;
